import { Injectable } from '@angular/core';

import { VersionService } from '../version.service';

const cacheVersionData = new Map<string, IVersionData>();
const DELAY = 10000;

@Injectable()
export class ServerVersionDataService {
    constructor(
        private _versionSrv: VersionService
    ) {
    }

    async getData(apiUrl: string): Promise<IVersionData> {
        if (cacheVersionData.has(apiUrl)) {
            return new Promise((resolve) => {
                resolve(cacheVersionData.get(apiUrl));
            });
        }

        let versionData: IVersionData = null;
        try {
            versionData = await this._versionSrv.getData(apiUrl);
            cacheVersionData.set(apiUrl, versionData);
            deleteCacheVersionData(apiUrl, DELAY);
        } catch (err) {
            throw err;
        }

        return versionData;
    }

    removeCacheItem(apiUrl: string) {
        cacheVersionData.delete(apiUrl);
    }
}

function deleteCacheVersionData(apiUrl: string, delay: number) {
    return setTimeout(() => {
        cacheVersionData.delete(apiUrl);
    }, delay);
}
